<app-card [title]="'Signatures'">
    <!-- Applicant Declaration Section -->
    <div>
        <h2>Applicant Declaration and Authorization</h2>
        <p [innerHTML]="declarationText"></p>
        <div class="signature-field">
            <mat-label class="signature-label">Sign Here*</mat-label>
            <canvas #signaturePad1 class="signature-pad" width="500" height="100" [class.disabled]="isSignature1Accepted">
            </canvas>
            <p class="error" *ngIf="signatureForm.get('ApplicatantDeclarationAuthorization_Signature')?.invalid && signatureForm.get('ApplicatantDeclarationAuthorization_Signature')?.touched">
                Applicant Declaration and Authorization Signature is required
            </p>
            <div class="signature-button-container">
                <button class="button-Secondary" type="button" (click)="clearSignature1()">
                    Clear Signature
                </button>
                <button class="button-Primary" type="button" (click)="acceptSignature1()"
                    [disabled]="isSignature1Accepted">
                    ACCEPT SIGNATURE
                </button>
            </div>
        </div>
    </div>

    <!-- Applicant Authorization Section -->
    <div>
        <h2>Applicant Authorization for Use and Disclosure of Personal Health Information</h2>
        <p [innerHTML]="authorizationText"></p>
        <div class="signature-field">
            <mat-label class="signature-label">Sign Here*</mat-label>
            <canvas #signaturePad2 class="signature-pad" width="500" height="100" [class.disabled]="isSignature2Accepted">
            </canvas>
            <p class="error" *ngIf="signatureForm.get('HealthInfoSharing_Signature')?.invalid && signatureForm.get('HealthInfoSharing_Signature')?.touched">
                Applicant Authorization for Use and Disclosure of Personal Health Information Signature is required
            </p>
            <div class="signature-button-container">
                <button class="button-Secondary" type="button" (click)="clearSignature2()">
                    Clear Signature
                </button>
                <button class="button-Primary" type="button" (click)="acceptSignature2()"
                    [disabled]="isSignature2Accepted">
                    ACCEPT SIGNATURE
                </button>
            </div>
        </div>
    </div>

    <div class="button-container">
        <button class="button-Primary" [disabled]="isSubmitDisabled" (click)="onSubmit()">SUBMIT APPLICATION</button>
    </div>
</app-card>

<loading-spinner *ngIf="isLoading"></loading-spinner>
